<div class="tab_body">
    <div class="flex-end" *ngIf="itemList?.length > 0">
        <button class="can" (click)="downloadCSV()" *ngIf="!isLoading">
            <mat-icon>cloud_download</mat-icon>
            Export CSV
        </button>
        <img [src]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="isLoading" />
    </div>
    <fury-list>
        <fury-list-table>
            <table class="lead_list" [dataSource]="dataSource" mat-table>
                <form [formGroup]="leadSearchForm"> 
                <ng-container matColumnDef="actions" stickyEnd>
                    <th *matHeaderCellDef class="actions-cell" mat-header-cell>
                        <div>
                            <div class="search" (click)="searchData()">
                                <mat-icon>search</mat-icon>
                            </div>
                        </div>
                        <h3>
                            Actions
                        </h3>
                    </th>
                    <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <button mat-menu-item (click)="navigateDetailsPage(row)">
                                <span>View</span>
                            </button>
                   
                        </mat-menu>
                    </td>
                </ng-container>

                <ng-container matColumnDef="addedOn" sticky>
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <div style="height: 50px;">
                                &nbsp;
                            </div>
                            <h3>
                                Added On
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{commonService.convertDate(element?.addedOn) | date : 'MMM-dd-YYYY h:mm a'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="First Name" formControlName="firstName"/>
                            <h3>
                                First Name
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.firstName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Last Name" formControlName="lastName"/>
                            <h3>
                                Last Name
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.lastName}}
                    </td>
                </ng-container>
                    <ng-container matColumnDef="verifiedName">
                        <th mat-header-cell *matHeaderCellDef>
                            <div>
                                <input type="text" placeholder="Verified Name" formControlName="verifiedName"/>
                                <h3>
                                    Verified Name
                                </h3>
                            </div>
                            
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element?.verifiedName}}
                        </td>
                    </ng-container>
                <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Email Address" formControlName="emailAddress"/>
                            <h3>
                                Email Address
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.emailAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="mobileNumber">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Mobile No" formControlName="mobileNumber" mask="0*"/>
                            <h3>
                                Mobile No
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.mobileNumber | mask : "(000) 000-0000"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="source">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Source"  formControlName="source"/>
                            <h3>
                                Source
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.source}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Address" formControlName="address"/>
                            <h3>
                                Address
                            </h3>
                        </div>
                    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.address?.streetAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="City" formControlName="city"/>
                            <h3>
                                City
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.address?.city}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="State" formControlName="state"/>
                            <h3>
                                State
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.address?.state}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="zipCode">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Zip Code" formControlName="zip" mask="0*"/>
                            <h3>
                                Zip Code
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.address?.zip}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="attempts">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Attempts" formControlName="attempts"/>
                            <h3>
                                Attempts
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.attempts}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="resultCode">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Result Code" formControlName="resultCode"/>
                            <h3>
                                Result Code
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.resultCode}}
                    </td>
                </ng-container>
                  <ng-container matColumnDef="soldAmount">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <div style="height: 50px;">
                                &nbsp;
                            </div>
                            <h3>
                                Total Cost
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.soldAmount | currency}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="vanillaSoftStatus">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Status" formControlName="status"/>
                            <h3>
                                Status
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.vanillaSoftStatus}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastAgentName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Last Agent Name"  formControlName="lastAgentName"/>
                            <h3>
                                Last Agent Name
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.lastAgentName ? element?.lastAgentName : ''}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="submission">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <div style="height: 50px;">
                                &nbsp;
                            </div>
                            <h3>
                                Submission
                            </h3>
                        </div>
                    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.submission?.ipAddress}} (IP), {{element?.submission?.mobileNumber}} (P), {{element?.submission?.emailAddress}} (E)
                    </td>
                </ng-container>
                <ng-container matColumnDef="vanillaSoftTimestamps">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <div style="height: 50px;">
                                &nbsp;
                            </div>
                            <h3>
                                Last Updated
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                    {{commonService.convertDate(element?.vanillaSoftTimestamps) | date : 'MMM-dd-YYYY h:mm a'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="leadStatus">
                    <th *matHeaderCellDef mat-header-cell>
                        <div style="height: 50px;">
                            &nbsp;
                        </div>
                        <h3>
                            Vanilla Soft Status
                        </h3>
                    </th>
                    <td *matCellDef="let element" mat-cell>
                        <mat-icon [ngStyle]="{'color': element?.postedFromVanillaSoft ? 'blue' : 'black'}">{{element?.isBlocked ? (element?.vanillaSoftUpdatedStatus ? 'done_all' : 'block') : 'task_alt'}}</mat-icon>
                    </td>
                </ng-container>
                <ng-container matColumnDef="thirdPartyStatus">
                    <th *matHeaderCellDef mat-header-cell>
                        <div style="height: 50px;">
                            &nbsp;
                        </div>
                        <h3>
                            3rd Party Status
                        </h3>
                    </th>
                    <td *matCellDef="let element" mat-cell>
                        <mat-icon>{{element?.thirdPartyStatus ? 'task_alt' : 'block'}}</mat-icon>
                    </td>
                </ng-container>
               <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns"
                    class="clickable route-animations-elements" mat-row>
                </tr>
                </form>
            </table>
            <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
                No Leads found.
            </div>
        </fury-list-table>
    
    </fury-list>
</div>
